import {get, post} from '~/utils/request';

export function getDefaultResumeId() {
  return get('/Resume/GetDefaultResumeID');
}

export function getResumeIntegrity(){
  return get('/Resume/GetResumeIntegrity');
}

export function getResumeInfo(){
  return get('/Resume/GetResumeInfo');
}

export function getBasicInfo(data) {
  return post('/Resume/GetBasicInfo', data);
}

export function getJobExpect(data) {
  return post('/Resume/GetJobExpect', data);
}

export function getEduExp(data) {
  return post('/Resume/GetEduExp', data);
}

export function getWorkExp(data) {
  return post('/Resume/GetWorkExp', data);
}

export function getProjectExp(data) {
  return post('/Resume/GetProjectExp', data);
}

export function getProfessionalSkill(data) {
  return post('/Resume/GetProfessionalSkill', data);
}

export function getCertificate(data) {
  return post('/Resume/GetCertificate', data);
}

export function getLanguageSkill(data) {
  return post('/Resume/GetLanguageSkill', data);
}

export function getSelfEvaluation(data) {
  return post('/Resume/GetSelfEvaluation', data);
}

export function getAdditionalInfo(data) {
  return post('/Resume/GetAdditionalInfo', data);
}

export function uploadResumeFile(data) {
  return post('/Resume/UploadResumeFile', data);
}

export function fullCityName(data) {
  return post('/Common/FullCityName', data);
}

export function uploadPhoto(data) {
  return post('/Resume/UploadPhoto', data);
}

export function operateBasicInfo(data) {
  return post('/Resume/OperateBasicInfo', data);
}

export function operateJobExpect(data) {
  return post('/Resume/OperateJobExpectMobile', data);
}

export function operateEdu(data) {
  return post('/Resume/OperateEduExp', data);
}

export function delEdu(data) {
  return post('/Resume/DelEduExp', data);
}

export function operateWork(data) {
  return post('/Resume/OperateWorkExp', data);
}

export function delWork(data) {
  return post('/Resume/DelWorkExp', data);
}

export function operateProject(data) {
  return post('/Resume/OperateProjectExp', data);
}

export function delProject(data) {
  return post('/Resume/DelProjectExp', data);
}

export function operateCertificate(data) {
  return post('/Resume/OperateCertificate', data);
}

export function operateLanguageSkill(data) {
  return post('/Resume/OperateLanguageSkill', data);
}

export function operateProfessionalSkill(data) {
  return post('/Resume/OperateProfessionalSkill', data);
}

export function operateSelfEvaluation(data) {
  return post('/Resume/OperateSelfEvaluation', data);
}

export function operateAdditionalInfo(data) {
  return post('/Resume/OperateAdditionalInfo', data);
}

export function addResume(data) {
  return post('/Resume/AddResumeInfo', data);
}

export function fullTextSearch(data) {
  return post('/Resume/FullTextSearch', data);
}

export function downloadResume(data) {
  return post('/Hr/DownloadResume', data);
}

export function happyRiceSetting() {
  return get('/Hr/HappyRiceSetting');
}

export function getChatQr(){
  return post('/');
}

export function letiaoBasicResume(data){
  return post('/Resume/LetiaoBasicResume', data);
}

export function letiaoResume(data){
  return post('/Resume/LetiaoResume', data);
}

// export function editHeadhunter(data) {
//   return request({
//     url: '/Headhunter/EditHeadhunter',
//     method: 'post',
//     data
//   });
// }

// export function operateProjectExp(data) {
//   return request({
//     url: '/Resume/OperateProjectExp',
//     method: 'post',
//     data
//   });
// }

// export function delProjectExp(data) {
//   return request({
//     url: '/Resume/DelProjectExp',
//     method: 'post',
//     data
//   });
// }
